import { weekendSkillsService } from "../../services/api";
import { Skill } from "../../types/skill/skill";

const skillsCache: Record<number, Skill[]> = {};

export async function loadSkills(weekendId: number): Promise<void> {
  try {
    const response = await weekendSkillsService.getAll(weekendId);
    const list: Skill[] = response.data;
    skillsCache[weekendId] = list.sort((a, b) => a.orderID - b.orderID);
  } catch (error) {
    console.error(`Failed to load skills for weekend ${weekendId}:`, error);
    skillsCache[weekendId] = [];
  }
}

export function getSkills(weekendId: number): Skill[] {
  return structuredClone(skillsCache[weekendId] ?? []).sort(
    (a, b) => a.orderID - b.orderID
  );
}